import { render, staticRenderFns } from "./test-environment.vue?vue&type=template&id=af729cd6&scoped=true&"
import script from "./test-environment.vue?vue&type=script&lang=js&"
export * from "./test-environment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af729cd6",
  null
  
)

export default component.exports